import { inject, Injectable } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { RouterStateSnapshot, TitleStrategy } from "@angular/router";
import { environment } from "../../../../environments/environment";

@Injectable({
  providedIn: "root"
})
export class AppTitleService extends TitleStrategy {
  private readonly titleService = inject(Title);

  updateTitle(snapshot: RouterStateSnapshot): void {
    const title = this.buildTitle(snapshot);

    if (title) {
      this.titleService.setTitle(`${title} - ${environment.ui.appName}`);
    }
  }
}
